const UserReducer = (state = {}, action) => {
    switch (action.type) {
        case "USER_TABLE":
            return Object.assign({}, state, {
                User_Table: action.data
            });
        default:
            return state;
    }
};

export default UserReducer;